import format from 'date-fns/format';
import { FORMAT_DATE } from 'constants/time';

// TODO move to helpers/user.js
export const getFormattedUserName = (employee) => {
  const name = [];
  if (employee.firstname) {
    name.push(employee.firstname);
  }
  if (employee.middlename) {
    name.push(employee.middlename);
  }
  if (employee.lastname) {
    name.push(employee.lastname);
  }

  return name.join(' ');
};

export const getFormattedEntity = (t, entity) => {
  // Поддержка старых и новых названий полей
  const loadingDate = entity.loading_from || entity.loading_date;
  const unloadingDate = entity.unloading_to || entity.unloading_date_to;

  const dateLoading = loadingDate ? format(new Date(loadingDate), FORMAT_DATE) : '';
  const dateUnloading = unloadingDate ? format(new Date(unloadingDate), FORMAT_DATE) : '';

  const loadingText = `${entity.loading_address?.country_code || ''} ${
    entity.loading_address?.city || entity.loading_address?.state_province || ''
  } ${dateLoading}`.trim();
  const unloadingText = `${entity.unloading_address?.country_code || ''} ${
    entity.unloading_address?.city || entity.unloading_address?.state_province || ''
  } ${dateUnloading}`.trim();
  const weightText = entity.weight ? `, ${entity.weight}${t('units.tons')}` : '';
  return `${loadingText} - ${unloadingText}, ${entity.designation_title || ''}${weightText}`;
};
